//@flow
import * as React from 'react';
import styled from 'styled-components';

// import SvgIconContainer from '../SvgIconContainer';
import colors from '../../assets/css/colors';
import { below } from '../../assets/css/media';

const CTAWrapper = styled.button`
	border: 0;
	background-color: transparent;
	color: ${colors.nrlDarkGreen};
	margin: 0;
	cursor: pointer;
	width: 50px;
	padding: 0;
	&:hover {
		color: ${colors.nrlDarkGreenHover};
	}
`;

const Icon = styled.div`
	height: 50px;
	width: 50px;
	box-sizing: border-box;
	border: 2px solid currentColor;
	background: white;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 50%;

	> svg {
		font-size: 24px;
	}

	${below.desktop`
		box-shadow: 0 0 10px 0 rgba(0,0,0,0.5);
	`}
`;

const Text = styled.p`
	font-weight: bold;
	color: inherit;
	text-align: center;
	font-size: 10px;
	line-height: 1;
	text-transform: uppercase;
	padding: 0 0.2em;
	margin: 0.85em 0 0;

	${below.desktop`
		display: none;
	`}
`;

type Props = {
	onClickCTA: Function,
	text: string,
	icon: React.Element<any>,
	className?: string
};

export default ({ onClickCTA, text, icon, className }: Props) => {
	return (
		<CTAWrapper onClick={onClickCTA} className={className}>
			<Icon>
				{icon}
			</Icon>
			<Text>
				{text}
			</Text>
		</CTAWrapper>
	);
};


// WEBPACK FOOTER //
// ./src/components/SidebarWidget/SidebarWidgetCTA.js